import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import pluralize from 'pluralize'

import getEntityById from '../selectors/getEntityById'
import isRoot from '../utils/isRoot'

import layouts from '../layouts'

class LayoutRenderer extends Component {
  render () {
    const {
      data,
      match
    } = this.props

    const {
      layout
    } = data

    if (!layout) {
      throw new Error(`Data must contain a layout: ${match.url}`)
    }

    const Layout = layouts[layout]

    if (!Layout) {
      throw new Error(`"${layout}" is not a valid Layout. Layouts must be registered in src/layouts/index.js`)
    }

    return (
      <Layout
        data={this.props.data}
        isRoot={this.props.isRoot}
        history={this.props.history} />
    )
  }
}

LayoutRenderer.propTypes = {
  data: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
  isRoot: PropTypes.bool
}

const mapStateToProps = (state, ownProps) => {
  const { params } = ownProps.match
  const dataType = pluralize(ownProps.dataType)

  return {
    data: getEntityById(state, dataType, params.id),
    isRoot: isRoot(state, ownProps.dataType, params.id)
  }
}

export default connect(mapStateToProps)(LayoutRenderer)



// WEBPACK FOOTER //
// ./src/components/LayoutRenderer.js